<div class="dialog-container page-container ">
    <div class="popup-header head-fixed">
        <div class="header-left">
            <div class="header-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24">
                    <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="1"
                        d="M15 19c0-2.21-2.686-4-6-4s-6 1.79-6 4m16-3v-3m0 0v-3m0 3h-3m3 0h3M9 12a4 4 0 1 1 0-8a4 4 0 0 1 0 8" />
                </svg>
            </div>
            <div class="header-text">
                <h2 class="header-title">{{ popupTitle }}</h2>
                <p *ngIf="popupSubtitle" class="header-subtitle">{{ popupSubtitle }}</p>
            </div>
        </div>

        <button mat-icon-button class="mat-dialog-close" (click)="closeDialog()">
            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24 24">
                <path fill="currentColor"
                    d="m12 12.708l-5.246 5.246q-.14.14-.344.15t-.364-.15t-.16-.354t.16-.354L11.292 12L6.046 6.754q-.14-.14-.15-.344t.15-.364t.354-.16t.354.16L12 11.292l5.246-5.246q.14-.14.345-.15q.203-.01.363.15t.16.354t-.16.354L12.708 12l5.246 5.246q.14.14.15.345q.01.203-.15.363t-.354.16t-.354-.16z" />
            </svg>
        </button>
    </div>
    <section mat-dialog-content class="mt-4 ">
        <form [formGroup]="providerForm">
            <div class="form-row">
                <div class="form-field" style="flex: none;">
                    <div class="fileupload-container d-flex" style="flex-direction: column;" appDnd
                        (fileDropped)="isDismissable ? '': onFileDropped($event)">

                        <!-- File Upload Section -->
                        <input type="file" [multiple]="false" #fileDropRef id="fileDropRef" (click)="onFileInputClick()"
                            (change)="onAssetImage($event.target)" [disabled]="isDismissable" accept="image/*" />

                        <!-- Preview Section -->
                        <div *ngIf="imagePreviewUrl" class="preview-box">
                            <img [src]="imagePreviewUrl" alt="Image Preview"
                                style="max-width: 100%; height: 100%; object-fit: cover; border-radius: 8px;">
                        </div>

                        <div *ngIf="!imagePreviewUrl">
                            <span class="mb-2 fs-11">Drag and drop logo here or click to upload</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-container">
                <div class="form-row ">
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Name</mat-label>
                        <input type="text" matInput required formControlName="name">
                        <mat-error *ngIf="providerForm.get('name')?.hasError('required')">
                            Name is required
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Speciality</mat-label>
                        <input type="text" matInput formControlName="speciality">
                    </mat-form-field>
                </div>
                <div class="form-row">
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Email</mat-label>
                        <input type="email" matInput required formControlName="email">
                        <mat-error *ngIf="providerForm.get('email')?.hasError('required')">
                            Email is required
                        </mat-error>
                        <mat-error *ngIf="providerForm.get('email')?.hasError('email')">
                            Invalid email address
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Phone</mat-label>
                        <input matInput formControlName="phone" required placeholder="+44 7123 456789">
                        <mat-error *ngIf="providerForm.get('phone')?.hasError('required')">
                            Phone Number is required
                        </mat-error>
                        <mat-error *ngIf="providerForm.get('phone')?.hasError('pattern')">
                            Invalid phone number
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="form-row">
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>address</mat-label>
                        <input matInput required formControlName="address">
                        <mat-error *ngIf="providerForm.get('address')?.hasError('required')">
                            address is required
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Years of experience</mat-label>
                        <input matInput formControlName="yearsOfExperience">
                    </mat-form-field>
                </div>
                <div class="form-row">
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>License Number</mat-label>
                        <input matInput formControlName="licenseNumber">
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="form-field" style="visibility: hidden;">
                        <mat-label>Expiry Date</mat-label>
                        <input matInput type="date">
                    </mat-form-field>
                </div>
            </div>
        </form>
    </section>
    <section mat-dialog-actions class="d-flex justify-content-end">
        <div class="d-flex gap-2">
            <button class="secondaryBtn" (click)="closeDialog()">
                <span class="btnContent">Cancel</span>
            </button>
            <button class="primaryBtn" (click)="onSubmit()" [disabled]="providerForm.invalid || isSubmitLoading">
                <span class="btnContent">
                    Submit
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24"
                        *ngIf="isSubmitLoading">
                        <path fill="none" stroke="#ffffff" stroke-linecap="round" stroke-width="1.5"
                            d="M12 6.99998C9.1747 6.99987 6.99997 9.24998 7 12C7.00003 14.55 9.02119 17 12 17C14.7712 17 17 14.75 17 12">
                            <animateTransform attributeName="transform" attributeType="XML" dur="1.26s" from="0,12,12"
                                repeatCount="indefinite" to="360,12,12" type="rotate" />
                        </path>
                    </svg>
                </span>
            </button>
        </div>
    </section>
</div>